import { z } from 'zod';

export const SendgridVerifiedSchema = z.object({
	domain: z.string(),
	subdomain: z.string(),
	sender: z.string(),
});

export const SendgridDomainCheckSchema = z.object({
	verified: z.array(SendgridVerifiedSchema),
	emailReady: z.boolean(),
});
